import styled from 'styled-components';

export const Img = styled.img`
	width: 16px;
	margin-right: 8px;
`;
